import { faq } from '@/mocks/homeData';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于在线吃瓜，你想知道的都在这里
          </p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faq.map((item, i) => (
            <div key={i} className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="inline-flex w-6 h-6 items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}